module.exports = __webpack_public_path__ + "static/determined-site-header-projectsuccess-a8fa3211e879bf6bf192ce14e03c4c96.jpg";